import { Link } from "react-router-dom";

const POL_VERSION = "v1";
const POL_DATE = "9 maja 2026";

export function Polityka() {
  return (
    <article className="max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
      <header className="mb-10">
        <p className="chip mb-3">DOKUMENT</p>
        <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tight">
          Polityka <span className="text-carp-primary">prywatności</span>
        </h1>
        <p className="mt-3 text-sm font-mono text-carp-ink/70">
          Wersja {POL_VERSION} · obowiązuje od {POL_DATE}
        </p>
      </header>

      <div className="brut bg-carp-paper p-6 sm:p-8 space-y-10 text-[15px] leading-relaxed text-carp-ink">
        <Section number="1" title="Administrator danych osobowych">
          <p>
            Administratorem danych osobowych przetwarzanych w związku z korzystaniem z serwisu mudcarp.pl jest:
          </p>
          <div className="brut bg-white p-4 my-2 not-italic">
            <p className="font-display font-bold text-lg">Tailored Apps Łukasz Kowalski</p>
            <p className="text-sm mt-1">
              ul. Gliniana 52A, 91-336 Łódź<br />
              NIP: PL7282614483<br />
              e-mail: <Mail />
            </p>
          </div>
          <p>
            Sprzedawca jest jedynym administratorem danych zbieranych w Serwisie. W transakcji nie uczestniczy żaden
            pośrednik finansowy ani odbiorca końcowy środków poza Sprzedawcą; podmioty wymienione w §4 pełnią wyłącznie
            rolę procesorów lub odrębnych administratorów technicznych.
          </p>
        </Section>

        <Section number="2" title="Cel i podstawa prawna przetwarzania">
          <p>Administrator przetwarza dane osobowe w następujących celach:</p>
          <div className="overflow-x-auto">
            <table className="w-full text-sm border-[3px] border-carp-ink">
              <thead className="bg-carp-ink text-carp-paper font-display font-bold uppercase">
                <tr>
                  <th className="text-left p-2 border-r-[3px] border-carp-paper">Cel</th>
                  <th className="text-left p-2 border-r-[3px] border-carp-paper">Podstawa prawna</th>
                  <th className="text-left p-2">Kategorie danych</th>
                </tr>
              </thead>
              <tbody className="divide-y-[3px] divide-carp-ink/20">
                <tr>
                  <td className="p-2 align-top">Zawarcie i realizacja umowy sprzedaży</td>
                  <td className="p-2 align-top font-mono text-xs">art. 6 ust. 1 lit. b RODO</td>
                  <td className="p-2 align-top">imię, e-mail, treść Wiadomości, dane płatności</td>
                </tr>
                <tr>
                  <td className="p-2 align-top">Wystawienie faktury VAT</td>
                  <td className="p-2 align-top font-mono text-xs">art. 6 ust. 1 lit. c RODO</td>
                  <td className="p-2 align-top">dane do faktury (NIP, nazwa, adres)</td>
                </tr>
                <tr>
                  <td className="p-2 align-top">Obsługa reklamacji i roszczeń</td>
                  <td className="p-2 align-top font-mono text-xs">art. 6 ust. 1 lit. b/f RODO</td>
                  <td className="p-2 align-top">dane kontaktowe, korespondencja</td>
                </tr>
                <tr>
                  <td className="p-2 align-top">Bezpieczeństwo Serwisu (logi techniczne)</td>
                  <td className="p-2 align-top font-mono text-xs">art. 6 ust. 1 lit. f RODO</td>
                  <td className="p-2 align-top">adres IP, user-agent, czas żądania, kod odpowiedzi</td>
                </tr>
                <tr>
                  <td className="p-2 align-top">Audyt i dowody (RequestLog, OutboundCall)</td>
                  <td className="p-2 align-top font-mono text-xs">art. 6 ust. 1 lit. f RODO</td>
                  <td className="p-2 align-top">metadane wywołań HTTP do dostawców usług</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Section>

        <Section number="3" title="Zakres zbieranych danych">
          <Ol>
            <Li>
              <b>Dane podawane przez Klienta:</b> imię (opcjonalne), adres e-mail, treść Wiadomości (do 500 znaków),
              wybrana kwota wpłaty, kanał płatności, dane do faktury (na żądanie).
            </Li>
            <Li>
              <b>Dane techniczne zbierane automatycznie:</b> adres IP, identyfikator sesji płatności Stripe, znacznik
              czasu, user-agent, ścieżka żądania, kod odpowiedzi (zapisywane w wewnętrznym logu HTTP — RequestLog).
            </Li>
            <Li>
              <b>Dane wymieniane z systemami zewnętrznymi:</b> identyfikatory transakcji Stripe, identyfikatory faktur
              Subiekt 123 (jeśli dotyczy), identyfikatory wywołań modeli AI (zapisywane w logu wywołań — OutboundCall).
            </Li>
            <Li>
              <b>Cookies i podobne technologie:</b> zob. §7.
            </Li>
          </Ol>
        </Section>

        <Section number="4" title="Odbiorcy danych">
          <p>
            Dane mogą być przekazywane następującym podmiotom przetwarzającym (procesorzy lub odrębni administratorzy):
          </p>
          <Ul>
            <li>
              <b>Stripe Payments Europe, Limited</b> — obsługa płatności (siedziba: Irlandia, podlega RODO; przekazywanie
              danych do USA na podstawie standardowych klauzul umownych UE).
            </li>
            <li>
              <b>Anthropic, PBC</b> — przetwarzanie tekstu Wiadomości w celu wygenerowania Odpowiedzi MudCarp (siedziba:
              USA, transfer na podstawie SCC). Treść Wiadomości nie jest wykorzystywana przez Anthropic do trenowania
              modeli, zgodnie z aktualną polityką prywatności Anthropic dla API.
            </li>
            <li>
              <b>ElevenLabs, Inc.</b> — synteza głosu Odpowiedzi MudCarp (siedziba: USA, SCC).
            </li>
            <li>
              <b>Insert Sp. z o.o.</b> (Subiekt 123) — wystawianie faktur VAT na żądanie Klienta (siedziba: Polska).
            </li>
            <li>
              Operator infrastruktury hostingowej — przechowywanie danych Serwisu i bazy danych zamówień.
            </li>
            <li>
              Organy państwowe — wyłącznie na żądanie i na podstawie obowiązujących przepisów prawa.
            </li>
          </Ul>
          <p className="text-sm text-carp-ink/70 italic">
            Administrator nie sprzedaje danych osobowych ani nie udostępnia ich w celach marketingowych podmiotom trzecim.
          </p>
        </Section>

        <Section number="5" title="Okres przechowywania">
          <Ol>
            <Li>
              Dane do realizacji zamówienia: do <b>6 lat</b> od zakończenia roku, w którym zamówienie zostało zrealizowane
              (okres przedawnienia roszczeń + obowiązki podatkowe).
            </Li>
            <Li>
              Dane do faktury: <b>5 pełnych lat</b> od końca roku rozliczeniowego (obowiązek podatkowy).
            </Li>
            <Li>
              Treść Wiadomości i wygenerowanej Odpowiedzi MudCarp: do <b>6 miesięcy</b> od dnia realizacji (cele dowodowe
              i audyt persony AI), po tym terminie automatycznie anonimizowana lub usuwana.
            </Li>
            <Li>
              Logi techniczne (RequestLog, OutboundCall): do <b>30 dni</b>; logi zdarzeń Kick (KickEvent): do <b>90 dni</b>.
            </Li>
            <Li>
              Korespondencja e-mail: do <b>3 lat</b> od ostatniej interakcji.
            </Li>
            <Li>
              Dane przetwarzane na podstawie zgody (jeżeli takie wystąpią): do momentu wycofania zgody.
            </Li>
          </Ol>
        </Section>

        <Section number="6" title="Prawa Klienta">
          <p>Każdej osobie, której dane dotyczą, przysługuje prawo do:</p>
          <Ul>
            <li>dostępu do danych — art. 15 RODO;</li>
            <li>sprostowania — art. 16 RODO;</li>
            <li>usunięcia („prawo do bycia zapomnianym") — art. 17 RODO, z zastrzeżeniem obowiązków prawnych Administratora;</li>
            <li>ograniczenia przetwarzania — art. 18 RODO;</li>
            <li>przenoszenia danych — art. 20 RODO;</li>
            <li>sprzeciwu wobec przetwarzania — art. 21 RODO;</li>
            <li>wycofania zgody w każdym momencie — art. 7 ust. 3 RODO (bez wpływu na zgodność z prawem przetwarzania przed wycofaniem);</li>
            <li>
              wniesienia skargi do organu nadzorczego — Prezesa Urzędu Ochrony Danych Osobowych
              (<ExtLink href="https://uodo.gov.pl">uodo.gov.pl</ExtLink>).
            </li>
          </Ul>
          <p>
            Realizacja praw: <Mail />.
          </p>
        </Section>

        <Section number="7" title="Cookies i podobne technologie">
          <Ol>
            <Li>
              Serwis używa wyłącznie <b>niezbędnych plików cookies</b> umożliwiających działanie aplikacji (np. utrzymanie
              sesji, przekierowanie do Stripe). Niezbędne cookies nie wymagają zgody.
            </Li>
            <Li>
              Serwis nie wykorzystuje własnych plików cookies marketingowych ani analitycznych.
            </Li>
            <Li>
              W trakcie procesu płatności Stripe może ustawić własne pliki cookies, w tym mające na celu zapobieganie
              oszustwom — szczegóły określa polityka cookies Stripe.
            </Li>
            <Li>
              Klient może zarządzać plikami cookies w ustawieniach swojej przeglądarki; wyłączenie cookies niezbędnych
              może uniemożliwić korzystanie z Serwisu.
            </Li>
          </Ol>
        </Section>

        <Section number="8" title="Bezpieczeństwo">
          <p>
            Administrator stosuje środki techniczne i organizacyjne odpowiednie do ryzyka, w tym: szyfrowanie połączeń (TLS),
            separację środowisk dev/prod, kontrolę dostępu, rejestr żądań i odpowiedzi (audit log) oraz automatyczne usuwanie
            logów po upływie okresu retencji.
          </p>
        </Section>

        <Section number="9" title="Zmiany Polityki Prywatności">
          <p>
            Administrator zastrzega prawo do aktualizacji niniejszego dokumentu. Aktualna wersja: <b>{POL_VERSION}</b>,
            data wejścia w życie: <b>{POL_DATE}</b>. O istotnych zmianach Klient zostanie poinformowany przy najbliższym
            kontakcie lub poprzez ogłoszenie w Serwisie z 14-dniowym wyprzedzeniem.
          </p>
        </Section>

        <Section number="10" title="Kontakt">
          <p>
            We wszystkich sprawach dotyczących danych osobowych: <Mail />.
          </p>
        </Section>

        <footer className="pt-6 border-t-[3px] border-carp-ink/20 flex flex-wrap items-center justify-between gap-4 text-sm">
          <Link to="/regulamin" className="link-brut">
            → Regulamin
          </Link>
          <Link to="/buy" className="btn-primary">
            Wracam do formularza
          </Link>
        </footer>
      </div>
    </article>
  );
}

// ─── Local helpers ──────────────────────────────────────────

function Section({ number, title, children }: { number: string; title: string; children: React.ReactNode }) {
  return (
    <section className="space-y-4">
      <h2 className="font-display font-bold text-2xl tracking-tight">
        <span className="text-carp-primary">§{number}</span> {title}
      </h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}

function Ol({ children }: { children: React.ReactNode }) {
  return <ol className="list-decimal pl-6 space-y-3 marker:font-mono marker:text-carp-ink/60">{children}</ol>;
}

function Li({ children }: { children: React.ReactNode }) {
  return <li className="leading-relaxed">{children}</li>;
}

function Ul({ children }: { children: React.ReactNode }) {
  return <ul className="list-disc pl-6 space-y-1 mt-2 marker:text-carp-ink/40">{children}</ul>;
}

function Mail() {
  return (
    <a href="mailto:kontakt@mudcarp.pl" className="link-brut">
      kontakt@mudcarp.pl
    </a>
  );
}

function ExtLink({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <a href={href} target="_blank" rel="noreferrer noopener" className="link-brut">
      {children}
    </a>
  );
}

export default Polityka;
